<div class="dialog rounded-0">
  <div class="dialog-header border-0 m-auto">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="dialog-content border-0 m-auto">
    <div class="text-center mb-1 dialog-text title">
      Loading...
      <br>
      This may take few minutes depending on the file size...
    </div>
  </div>
</div>


